<template>
  <loginLayout>
    <div class="login-panl">
      <div class="flex-content-between">
        <h1 class="title">智绘网络 · 用户登录</h1>
        <router-link class="link" to="/sige">立即注册</router-link>
      </div>
      <div class="f-wrapper">
        <Input
          class="login-input"
          placeholder="用户ID/手机号码/账户邮箱"
          clearable
          v-model="form.name"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <Input
          v-if="step === 0"
          class="login-input login-pswd"
          type="password"
          placeholder="请输入登录密码"
          clearable
          v-model="form.password"
        >
          <template #prefix>
            <img
              class="login-name2"
              src="../../assets/image/user-login-icon2.png"
              alt=""
            />
          </template>
        </Input>
        <div class="flex-content-between login-pswd" v-if="step === 1">
          <Input
            class="login-input"
            type="password"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            style="width: 200px"
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon3.png"
                alt=""
              />
            </template>
          </Input>
          <Button
              ref="smsBtn"
              class="sms-btn"
              shape="circle"
              height="60px"
              @click="refreshCode"
              :disabled="codeDisabled"
              style="width: 120px"
          >{{text1}}</Button>
        </div>
        <div class="flex-content-between" style="margin-top: 50px">
          <Checkbox class="c-check" v-model="single">记住我</Checkbox>
          <div class="sms-check" @click="stepClick">{{ text }}</div>
          <router-link class="f-link" to="/forgot">忘记密码？</router-link>
        </div>
        <Button
          class="login-btn"
          type="primary"
          shape="circle"
          long
          :loading="loading"
          @click="submit"
          >登录</Button
        >
      </div>
      <Modal
          v-model="verifyshow"
          title="验证码"
          @on-ok="getCodeEvent"
          @on-cancel="verifyshow = false">
        <div class="verify-info">
          <div class="verify-code">
            <span class="verify-label">验证码</span>
            <div class="verify-block">
              <img id="verificationCode" class="verify-img" @click="refreshCode">
            </div>
          </div>
          <input
              v-model="codeValue"
              class="verify-input"
              placeholder="请输入验证码"
          >
        </div>
      </Modal>
    </div>
  </loginLayout>
</template>

<script>
import loginLayout from "./components/loginLayout.vue";
import smsBtn from "components/smsBtn.vue";
import { mapMutations, mapState } from "vuex";
import { getEncrypt } from "utils/encrypt";
import { getCode, login, getAmountInfo, getMemberInfo } from "api/user.js";
import { Base64 } from "js-base64";
export default {
  name: "login",
  components: {
    loginLayout,
    smsBtn,
  },
  data() {
    return {
      step: 0, // 0 密码登录 1 短信登录
      single: false,
      form: {
        name: "",
        password: "",
        code: "",
      },
      loading: false,
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  watch: {
    step: {
      immediate: true,
      handler(val) {
        if (val === 0) {
          const rememberMe = localStorage.getItem("U_RememberMe");
          if (rememberMe && rememberMe === "true") {
            this.form.name = localStorage.getItem("U_ID");
            this.form.password = Base64.decode(
              localStorage.getItem("U_Secret")
            );
          }
          this.single = rememberMe === "true";
        }
      },
    },
  },
  computed: {
    ...mapState(["prevRouter"]),
    text() {
      return this.step === 0 ? "短信登录" : "密码登录";
    },
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${process.env.VUE_APP_API}cczhweb/sms/login/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    ...mapMutations(["MUT_TOKEN_INFO", "MUT_AMOUNT", "MUT_USER_INFO"]),
    stepClick() {
      this.step = this.step === 0 ? 1 : 0;
    },
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码！");
        this.$refs.smsBtn.reset();
        return;
      }
      getCode(this.form.name, this.codeValue)
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.codeDisabled = true
            this.text1 = `${i--}秒后再获取`;
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text1 = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text1 = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
        });
    },
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入手机号码！");
        return false;
      }
      if (this.step === 1) {
        if (!this.form.code) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
      }else{
        if (!this.form.password) {
          this.$Message.warning("请输入密码！");
          return false;
        }
      }

      let params = {
        account: this.form.name,
        type: this.step,
        source: 0,
      };

      this.step === 0
        ? (params["password"] = getEncrypt(this.form.password))
        : (params["verifyCode"] = this.form.code);
      this.loading = true;
      login(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200 && res.result) {
            if (this.single) {
              localStorage.setItem("U_ID", this.form.name);
              localStorage.setItem(
                "U_Secret",
                Base64.encode(this.form.password)
              );
              localStorage.setItem("U_RememberMe", this.single);
            }
            this.MUT_TOKEN_INFO(res.data);
            Promise.all([getAmountInfo(), getMemberInfo()]).then((res2) => {
              const { code, data, result } = res2[0];
              const { code: code2, data: data2, result: result2 } = res2[1];
              if (code === 200 && result) {
                this.MUT_AMOUNT(data);
              }
              if (code2 === 200 && result2) {
                this.MUT_USER_INFO(data2);
              }
              this.$Message.success("登录成功!");
              this.$router.replace(this.prevRouter);
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.login-panl {
  display: block;
  width: 506px;
  height: 615px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 196px;
  transform: translateY(-50%);
  padding: 110px 63px 125px;
  .title {
    font-size: 16px;
    line-height: 60px;
    font-weight: bold;
    color: #333333;
  }
  .link {
    line-height: 60px;
    color: #ff5c35;
    font-weight: 400;
    font-size: 14px;
    margin-right: 16px;
  }
  .f-wrapper {
    margin-top: 40px;
    .login-name {
      margin-top: 22px;
    }
    .login-pswd {
      margin-top: 40px;
    }
    .login-name2 {
      margin-top: 18px;
    }
    .f-link {
      color: #999999;
    }
    .sms-check {
      cursor: pointer;
      color: #ff5c35;
      font-weight: 400;
    }
  }
  /deep/.c-check {
    .ivu-checkbox {
      margin-right: 15px;
    }
    color: #999999;
  }
  /deep/.login-btn {
    margin-top: 40px;
    height: 60px;
    font-size: 14px;
    font-weight: 400;
  }
  /deep/.login-input {
    .ivu-input {
      height: 60px !important;
      line-height: 60px !important;
      border-radius: 40px;
      padding: 0 30px 0 50px !important;
      font-size: 16px;
      font-weight: 400;
      line-height: 60px;
    }
    .ivu-input-prefix {
      padding-left: 20px;
      width: auto;
      line-height: 60px;
    }
    .ivu-input-icon-clear {
      line-height: 60px;
      font-size: 24px;
    }
  }
}
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
::v-deep .ivu-modal-content {
  background-color: #fff!important;
}
.sms-btn /deep/ {
  .ivu-btn {
    width: 100%;
    height: 100%;
    background-color: #F85A36;
    color: #fff;
    &:hover{
      border-color: #F85A36;
    }
  }
}
</style>
